export const CHANNEL_OPPS = 'channel_opps';
export const TOTAL = 'Total';
export const LOCAL_WEBSITE = 'Local Website';
export const OTHER = 'Other';
export const CHANNEL_OPPS_WITHOUT_LOCAL = 'channel_opps_local';
export const YOY_OPPS_SPEND_BY_CHANNEL = 'yoy_opps_spend_by_channel';
export const OPPS_SPEND_CHANNEL_VENDOR_SEM = 'opps_spend_by_channel_vendor_sem_only';
export const OPPS_SPEND_CHANNEL_VENDOR_SEM_WITH_STORE =
  'opps_spend_by_channel_vendor_sem_only_with_store';
// Opps by channel new color Palette
export const DARK_RED_OPPS = '#FD7A7B';
export const LIGHT_RED_OPPS = '#FFADAD';
export const LIGHT_GREEN_OPPS = '#CFF5D0';
export const DARK_GREEN_OPPS = '#4BD64B';
// YoY table const
export const YOY_CHANNEL_PERFORMANCE_FILTER = {
  current_query_builder: {
    filters: [
      {
        col: 'dateindex',
        op: '>=',
        val: '',
      },
      {
        col: 'dateindex',
        op: '<=',
        val: '',
      },
      {
        col: 'store_id',
        op: '==',
        val: '',
      },
    ],
  },
  previous_query_builder: {
    filters: [
      {
        col: 'dateindex',
        op: '>=',
        val: '',
      },
      {
        col: 'dateindex',
        op: '<=',
        val: '',
      },
      {
        col: 'store_id',
        op: '==',
        val: '',
      },
    ],
  },
  join_columns: ['channel_name'],
};
export const YOY_TOTAL = 'Grand Total';
export const DOWNLOAD_FILE_NAME = 'opps_by_channel__channel_opps.xlsx';
export const SUB_BRANCH_DASH_OPPS_BY_CHANNEL_DOWNLOAD_FILE_NAME =
  'sub_branch_opps_by_channel__channel_opps.xlsx';
export const DOWNLOAD_FILE_NAME_LOCAL_SPEND = 'opps_by_channel__channel_opps_local_spend.xlsx';
export const SUB_BRANCH_DASH_DOWNLOAD_FILE_NAME_LOCAL_SPEND =
  'sub_branch_opps_by_channel__channel_opps_local_spend.xlsx';
export const DOWNLOAD_CHANNEL_OPPS_STORE = 'channel_opps_with_store';
export const DOWNLOAD_CHANNEL_OPPPS_LOCAL = 'channel_opp_by_channel_local_spend';
export const SEM_OPPS_DOWNLOAD_FILE_NAME = 'opps_by_channel__sem_channel_opps.xlsx';
export const SUB_BRANCH_SEM_OPPS_DOWNLOAD_FILE_NAME =
  'sub_branch_opps_by_channel__sem_channel_opps.xlsx';
